import { MessageType, PushNotificationEventType } from '@/enums';
import type { InputLiveStatusResponse } from '@/models/input';
import { FuelToolsApiService } from '@/services/FuelToolsApi/fuelToolsApi.service';

export interface InputStatusUpdatePayload {
  inputId: string;
  overallStatus?: string;
}

function readOverallStatus(data?: Record<string, unknown> | null): string | undefined {
  if (!data) {
    return undefined;
  }

  return (data.overallStatus ?? data.OverallStatus) as string | undefined;
}

export function parseInputStatusUpdateMessage(message: unknown): InputStatusUpdatePayload | null {
  if (!message || typeof message !== 'object') {
    return null;
  }

  const msg = message as { messageType?: string; data?: Record<string, unknown> };
  if (msg.messageType !== MessageType.Notification || !msg.data) {
    return null;
  }

  if (msg.data.eventType !== PushNotificationEventType.InputStatusUpdate) {
    return null;
  }

  const inputId = (msg.data.id ?? msg.data.inputId) as string | undefined;
  if (!inputId) {
    return null;
  }

  const overallStatus = readOverallStatus(msg.data);

  console.log('[InputStatus] WebSocket message parsed', { inputId, overallStatus });

  return {
    inputId,
    overallStatus,
  };
}

export async function resolveInputStatusUpdate(
  payload: InputStatusUpdatePayload
): Promise<InputLiveStatusResponse & { inputId: string }> {
  if (payload.overallStatus != null) {
    console.log('[InputStatus] Using overallStatus from WebSocket payload', {
      inputId: payload.inputId,
      overallStatus: payload.overallStatus,
    });
    return {
      inputId: payload.inputId,
      overallStatus: payload.overallStatus,
    };
  }

  const response = (await FuelToolsApiService.getInputStreamStatus(payload.inputId)) as Record<string, unknown>;
  const resolved = {
    inputId: payload.inputId,
    overallStatus: readOverallStatus(response),
    liveProgramIds: response?.liveProgramIds as string[] | undefined,
  };
  console.log('[InputStatus] Fetched overallStatus from API', resolved);
  return resolved;
}
